import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=a9d67a08&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=a9d67a08&prod&lang=scss&"
import style1 from "./edit.vue?vue&type=style&index=1&id=a9d67a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d67a08",
  null
  
)

export default component.exports